export const createHTTPHeader = (authToken) => {
  const token = authToken === null ? 'test' : authToken
  return {
    Authorization: `Bearer ${token}`
  }
}
